import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import NavBar from "../../../../components/Navbar";
import { useState } from "react";
import SimpleMail from "./SimpleMail";
import SecureMail from "./SecureMail";
import Inbox from "./InboxMessages";
import { Message, Physician, Recipient } from "../../../../store";  //FB 9639
import {
  GetMessageReplies,
  GetAllPhysicians,
  GetEmployeeGroups,
  GetInboxMessages,
  GetSentMessages,
} from "../../../../api"; //FB 9639,//FB 10088
import SentMessages from "./sentMessages";
import ChatMsg from "./ChatMsg";
import DirectMail from "./DirectMail";  //FB 7075
import { Menu, MenuItem, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, ThemeProvider, Dialog, DialogContent, CircularProgress, useTheme } from "@mui/material"; //FB 7113 //FB 6997

// Update log
// FB  6192   02/06/2023  DK   Added page to handle messages screen
// FB  7075   08/03/2023  DK  Implement direct messaging feature
// FB  7113   08/29/2023  SK  Patient Portal: Hide the Secure E-mail option and provide only one option to send message
// FB  6997   10/09/2023  SK   Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  8584   05/14/2024  SK  Portal Loading takes long for multiple tabs
// FB  9639   12/02/2024  DK  Employee Groups that are Set to be Portal Addressees.
// FB  10088   05/15/2025  GS  Allow to send the message from EMR to portal only

export default function Messages() {
  const [show, setShow] = useState(false);
  const [showmail, setShowMail] = useState(false);
  const [showDirectmail, setShowDirectMail] = useState(false);  //FB 7075
  const [showinbox, setShowIbox] = useState(true);
  const [showsent, setShowSent] = useState(false);
  const [chatMsg, setChatMsg] = useState(false);
  const [inboxMessages, setInboxMessages] = useState<Message[]>();
  const [sentMessages, setSentMessages] = useState<Message[]>();
  const [recipients, setRecipients] = useState<Recipient[]>([]);  //FB 9639
  const [isSimpleActive, setSimpleMailActive] = useState(false);
  const [isSecureMailActive, setSecureMailActive] = useState(false);
  const [isDirectMailActive, setDirectMailActive] = useState(false);  //FB 7075
  const [isInboxActive, setInboxActive] = useState(true);
  const [isSentActive, setSentActive] = useState(false);
  const [isAllowReplies, setAllowReplies] = useState(true);//FB 10088
  //FB 7113 - Begin
  const [value, setValue] = useState('');
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
    let data = ((event.target as HTMLInputElement).value);
    if (data == "Office") {
      sendMessages();

    }
    else if (data == "DirectMessage") {
      showDirectMail();

    }
    else if (data == "SecureEmail") {
      showSecureMail();

    }
    else if (data == "SimpleEmail") {
      showSimpleMail();

    }
  };
  const handleMessages = () => {
    if (value == "Office") {
      sendMessages();

    }
    else if (value == "DirectMessage") {
      showDirectMail();

    }
    else if (value == "SecureEmail") {
      showSecureMail();

    }
    else if (value == "SimpleEmail") {
      showSimpleMail();

    }
  }
  //FB 7113 - End
  const sendMessages = () => {
    setSimpleMailActive(false);
    setSecureMailActive(false);
    setDirectMailActive(false); //FB 7075
    setInboxActive(false);
    setSentActive(false);
    setChatMsg(true);
    setShow(false);
    setShowMail(false);
    setShowDirectMail(false); //FB 7075
    setShowIbox(false);
    setShowSent(false);
  };
  const showSimpleMail = () => {
    setChatMsg(false);
    setSimpleMailActive(true);
    setSecureMailActive(false);
    setDirectMailActive(false); //FB 7075
    setInboxActive(false);
    setSentActive(false);
    setShow(true);
    setShowMail(false);
    setShowDirectMail(false); //FB 7075
    setShowIbox(false);
    setShowSent(false);
  };
  const showSecureMail = () => {
    setChatMsg(false);
    setSimpleMailActive(false);
    setSecureMailActive(true);
    setDirectMailActive(false); //FB 7075
    setInboxActive(false);
    setSentActive(false);
    setShowMail(true);
    setShow(false);
    setShowDirectMail(false); //FB 7075
    setShowIbox(false);
    setShowSent(false);
  };
  //FB 7075
  const showDirectMail = () => {
    setChatMsg(false);
    setSimpleMailActive(false);
    setSecureMailActive(false);
    setDirectMailActive(true);
    setInboxActive(false);
    setSentActive(false);
    setShowMail(false);
    setShow(false);
    setShowDirectMail(true);
    setShowIbox(false);
    setShowSent(false);
  };
  const showInbox = () => {
    setValue('');//FB 7113
    setChatMsg(false);
    setSimpleMailActive(false);
    setSecureMailActive(false);
    setDirectMailActive(false); //FB 7075
    setInboxActive(true);
    setSentActive(false);
    setShowIbox(true);
    setShow(false);
    setShowDirectMail(false); //FB 7075
    setShowMail(false);
    setShowSent(false);
  };
  const showSentMessages = () => {
    setValue('');//FB 7113
    setChatMsg(false);
    setSimpleMailActive(false);
    setSecureMailActive(false);
    setDirectMailActive(false); //FB 7075
    setInboxActive(false);
    setSentActive(true);
    setShowSent(true);
    setShowIbox(false);
    setShowDirectMail(false); //FB 7075
    setShow(false);
    setShowMail(false);
  };
  let patientName = "User";
  let patientLastName;
  let patientFullName: string;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    patientLastName = JSON.parse(data).PatientLastName;
    patientFullName = patientName.concat(" ", patientLastName);
  }
  async function GetInbox() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        const data = await GetInboxMessages(user.Patient_n);
        setInboxMessages(data);
      }
    }
  }

  async function GetSent() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        const data = await GetSentMessages(user.Patient_n);
        setSentMessages(data);
      }
    }
  }

  //FB 9639
  async function GetRecipients() {
    var userInfo = sessionStorage.getItem("user");
    if (userInfo != null) {
      const user = JSON.parse(userInfo);
      if (user.Patient_n != null) {
        var physicians = await GetAllPhysicians();
        var filteredPhysicians = physicians.filter((x: any, idx: number) => idx < 50);
        var physicianRecipients: Recipient[] = filteredPhysicians.map((physician: any) => { return { ID: physician.ID, Name: physician.Name, Is_Group: false } as Recipient });
        var groups = await GetEmployeeGroups();
        var groupRecipients: Recipient[] = groups.map((group: any) => { return { ID: group.id, Name: group.groups_name, Is_Group: true } as Recipient });
        let recipients = physicianRecipients.concat(groupRecipients);
        setRecipients(recipients);
      }
    }
  }

  //FB 6997 - Begin
  const [showSpinner, setShowSpinner] = useState(false);
  const theme = useTheme();
  //FB 6997 - End

  useEffect(() => {
    setShowSpinner(true);//FB 6997
    GetMessageReplies().then(setAllowReplies);//FB 10088
    GetRecipients();  //FB 9639
    GetInbox();
    GetSent();
    //FB 6997 - Begin
    setTimeout(() => {
      setShowSpinner(false);
    }, 3000);
    //FB 8584
    //FB 6997 - End
  }, []);

  return (
    <div>
      <NavBar />
      <div className="row" style={{ backgroundColor: "#F5F5F5" }}>
        <div className="col">
          <div className="card" style={stylestart.container}>
            <div className="wrapper">
              <nav id="sidebar">
                <div className="sidebar-header">
                  <h4
                    style={{
                      //styleName: Desktop type/Header 1;

                      fontSize: "32px",
                      fontWeight: "700",
                      lineHeight: "40px",
                      letterSpacing: "0em",
                      textAlign: "left",
                    }}
                  >
                    &nbsp;Messages
                  </h4>
                </div>
                <br></br>
                <ul className="list-unstyled components">
                  {/* Deleted unused part of code - FB 7113*/}
                  <NavLink
                    to="#"
                    style={{
                      textDecoration: "none",
                    }}
                    onClick={handleMessages}//FB 7113
                  >
                    &nbsp;{" "}
                    <button
                      className="btn"
                      title="Send Message to Physician"
                      style={{
                        backgroundColor: "#13607C",
                        color: "white",
                        width: "190px",
                      }}
                      disabled={!isAllowReplies} // FB 10088
                    >
                      Send a new message
                    </button>{" "}
                    &nbsp;
                  </NavLink>
                  {/* FB 10088 Conditional message when replies are not allowed */}
                  {!isAllowReplies && (
                    <div style={{ fontWeight: "bold", color: "#b00020", paddingTop: "10px", paddingLeft: "10px", fontSize:"12px" }}>
                      The patient cannot reply or send messages to the office. Please contact the office.
                    </div>
                  )}
                  {/* FB 7113 - Begin */} 
                  {/* FB 10088 */}
                  <FormControl style={{ paddingLeft: "20px" }} disabled={!isAllowReplies}>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={value}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel value="Office" control={<Radio />} label="To Office" />
                      <FormLabel id="demo-controlled-radio-buttons-group">To External Address</FormLabel>
                      <FormControlLabel value="DirectMessage" control={<Radio />} label="Via Direct E-Mail" />
                      <FormControlLabel value="SimpleEmail" control={<Radio />} label="Via Simple E-mail" />
                    </RadioGroup>
                  </FormControl>
                  {/* FB 7113 - End */}
                  <br></br>
                  <br></br>
                  <NavLink
                    to="#"
                    style={{
                      fontWeight: "bold",
                      textDecoration: "none",
                      backgroundColor: isInboxActive ? "white" : "",
                      color: isInboxActive ? "#13607C" : "",
                      borderRadius: "7px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      paddingLeft: "15px",
                    }}
                    onClick={showInbox}
                  >
                    Inbox&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                    {/* &nbsp; Inbox&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; */}
                  </NavLink>
                  <br></br>

                  <br></br>
                  <NavLink
                    to="#"
                    style={{
                      fontWeight: "bold",
                      textDecoration: "none",
                      backgroundColor: isSentActive ? "white" : "",
                      color: isSentActive ? "#13607C" : "",
                      borderRadius: "7px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      paddingLeft: "15px",
                    }}
                    onClick={showSentMessages}
                  >
                    Sent &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  </NavLink>
                  <br></br>
                  <br></br>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="col-sm-9">
          {show && <SimpleMail />}
          {showmail && <SecureMail />}
          {/* FB 7075 */}
          {showDirectmail && <DirectMail />}
          {/* FB 9639 */}
          {showinbox && (
            <Inbox messages={inboxMessages} recipients={recipients} />
          )}
          {/* FB 9639 */}
          {showsent && (
            <SentMessages messages={sentMessages} recipients={recipients} />
          )}
          {chatMsg && <ChatMsg />}
        </div>
        {/* FB 6997 - Begin */}
        <ThemeProvider theme={theme}>
          <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
            <DialogContent
              style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress style={{ color: "#083A4D" }} />
            </DialogContent>
          </Dialog>
        </ThemeProvider>
        {/* FB 6997 - End */}
      </div>
    </div>
  );
}
const stylestart = {
  container: {
    border: "1px grey",
    paddingTop: "20px",
    backgroundColor: "#F5F5F5",
    paddingLeft: "80px",
    marginBottom: "20px" //FB 7113
  },
};
const stylestop = {
  container: {
    top: 20,
    left: 50,
    height: 200,
    border: "1px grey",
  },
};
